import { Comment as CommentIcon } from '@mui/icons-material';
import { Button, Container, useMediaQuery } from '@mui/material';
import { breakpoint4 } from '../../../../utils/layouts';

import './CommentsButton.scss';

interface CommentsButtonProps {
    count?: number;
    onClickHandler: React.MouseEventHandler<HTMLButtonElement>;
}

const CommentsButton = (props: CommentsButtonProps): JSX.Element => {
    const mobileLandscapePlus = useMediaQuery(breakpoint4);

    return (
        <Button
            variant='outlined'
            className='comment-button'
            onClick={props.onClickHandler}
        >
            <CommentIcon />
            {mobileLandscapePlus && (
                <Container className='comment-button-text'>Comment</Container>
            )}
            {Boolean(props.count) && (
                <Container className='comment-button-count'>
                    ({props.count})
                </Container>
            )}
        </Button>
    );
};

export default CommentsButton;
